import React from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import CurrencyInput from '../CurrencyInput';

function SreaModal({ show, onClose, onSubmit, form, handleChange, programas = [] }) {
      // Saldo Anterior State
      const [saldoConta, setSaldoConta] = React.useState([]);
      const [saldoInvestimento, setSaldoInvestimento] = React.useState([]);
      const [isLoadingSaldo, setIsLoadingSaldo] = React.useState(false);
      const [errorSaldo, setErrorSaldo] = React.useState(null);
      const [totalVlrC, setTotalVlrC] = React.useState(0);
      const [totalVlrK, setTotalVlrK] = React.useState(0);
      const [sreaEntries, setSreaEntries] = React.useState([]);
      const [ajusteVlrC, setAjusteVlrC] = React.useState(0);
      const [ajusteVlrK, setAjusteVlrK] = React.useState(0);

      React.useEffect(() => {
        if (!show) return;
        const token = localStorage.getItem('token');
        const cnpj = localStorage.getItem('cnpj');
        const ano = localStorage.getItem('ano');
        if (!token || !cnpj || !ano) return;
        setIsLoadingSaldo(true);
        setErrorSaldo(null);
        Promise.all([
          axios.get(`${API_BASE_URL.SALDO_CONTA}`, { params: { idEscola: cnpj, ano }, headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_BASE_URL.SALDO_INVESTIMENTO}/search`, { params: { idEscola: cnpj, ano }, headers: { Authorization: `Bearer ${token}` } })
        ])
          .then(([contaRes, investimentoRes]) => {
            setSaldoConta(contaRes.data || []);
            setSaldoInvestimento(investimentoRes.data || []);
          })
          .catch(() => setErrorSaldo('Erro ao carregar saldos.'))
          .finally(() => setIsLoadingSaldo(false));
      }, [show]);

      // Calcular totais de custeio e capital para o programa selecionado
      React.useEffect(() => {
        if (!show || !form.idPrograma) { setTotalVlrC(0); setTotalVlrK(0); return; }
        const token = localStorage.getItem('token');
        const cnpj = localStorage.getItem('cnpj');
        const ano = localStorage.getItem('ano');
        // A API /srea/search não aceita idPrograma, então buscamos todos e filtramos no cliente
        axios.get(`${API_BASE_URL.SREA}/search`, { params: { idEscola: cnpj, ano }, headers: { Authorization: `Bearer ${token}` } })
          .then(r => {
            const data = Array.isArray(r.data) ? r.data : [];
            setSreaEntries(data);
            const filtered = data.filter(it => String(it.idPrograma) === String(form.idPrograma));
            const c = filtered.reduce((acc, it) => acc + (parseFloat(it.vlrC || 0) || 0), 0);
            const k = filtered.reduce((acc, it) => acc + (parseFloat(it.vlrK || 0) || 0), 0);
            setTotalVlrC(c);
            setTotalVlrK(k);
          })
          .catch(() => { setTotalVlrC(0); setTotalVlrK(0); });
      }, [show, form.idPrograma]);

      // Carregar ajustes da tabela srea_ajuste e somar por programa
      React.useEffect(() => {
        if (!show || !form.idPrograma) { setAjusteVlrC(0); setAjusteVlrK(0); return; }
        const token = localStorage.getItem('token');
        const cnpj = localStorage.getItem('cnpj');
        const ano = localStorage.getItem('ano');
        axios.get(`${API_BASE_URL.SREA_AJUSTE}/search`, { params: { idEscola: cnpj, ano }, headers: { Authorization: `Bearer ${token}` } })
          .then(r => {
            const data = Array.isArray(r.data) ? r.data : [];
            const filtered = data.filter(it => String(it.idPrograma) === String(form.idPrograma));
            const c = filtered.reduce((acc, it) => acc + (parseFloat(it.vlrC || 0) || 0), 0);
            const k = filtered.reduce((acc, it) => acc + (parseFloat(it.vlrK || 0) || 0), 0);
            setAjusteVlrC(c);
            setAjusteVlrK(k);
          })
          .catch(() => { setAjusteVlrC(0); setAjusteVlrK(0); });
      }, [show, form.idPrograma]);

      // Monta tabela Saldo Anterior filtrada pelo programa selecionado
      const contasMap = {};
      saldoInvestimento.forEach(i => {
        if (!i.idConta) return;
        if (!contasMap[i.idConta]) contasMap[i.idConta] = { saldoFinal: 0, saldoInicial: 0, programa: i.programa, idPrograma: i.idPrograma, idConta: i.idConta };
        contasMap[i.idConta].saldoInicial += Number(i.inicial ?? 0);
        if (i.programa) contasMap[i.idConta].programa = i.programa;
        if (i.idPrograma) contasMap[i.idConta].idPrograma = i.idPrograma;
      });
      saldoConta.forEach(c => {
        if (!c.idConta) return;
        if (!contasMap[c.idConta]) contasMap[c.idConta] = { saldoFinal: 0, saldoInicial: 0, programa: c.programa, idPrograma: c.idPrograma, idConta: c.idConta };
        contasMap[c.idConta].saldoFinal += Number(c.saldoFinal ?? c.final ?? 0);
        if (c.programa) contasMap[c.idConta].programa = c.programa;
        if (c.idPrograma) contasMap[c.idConta].idPrograma = c.idPrograma;
      });
      function parseContaNum(idConta) {
        // Extrai o número inicial da conta para ordenação
        const m = String(idConta).match(/^\d+/);
        return m ? parseInt(m[0], 10) : 0;
      }
      const contasArray = Object.values(contasMap)
        .filter(item => String(item.idPrograma) === String(form.idPrograma))
        .map(item => ({
          idConta: item.idConta,
          programa: item.programa || '',
          valor: item.saldoFinal + item.saldoInicial
        }))
        .sort((a, b) => {
          const nA = parseContaNum(a.idConta);
          const nB = parseContaNum(b.idConta);
          if (nA !== nB) return nA - nB;
          return String(a.idConta).localeCompare(String(b.idConta));
        });

      function formatCurrency(value) {
        if (value == null) return '-';
        return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }
      function parseBRNumber(value) {
        if (value == null) return 0;
        if (typeof value === 'number') return value;
        let s = String(value).trim();
        if (!s) return 0;
        // keep digits, comma, dot, minus
        s = s.replace(/[^0-9,.-]/g, '');
        // If contains comma, treat as Brazilian format: dots are thousands, comma decimal
        if (s.indexOf(',') !== -1) {
          s = s.replace(/\./g, '').replace(/,/g, '.');
          const n = parseFloat(s);
          return Number.isFinite(n) ? n : 0;
        }
        // No comma: if it's an ordinary decimal with dot (e.g. "1234.56") parse directly
        if (/^-?[0-9]+\.[0-9]+$/.test(s)) {
          const n = parseFloat(s);
          return Number.isFinite(n) ? n : 0;
        }
        // Otherwise remove non-digits and parse integer
        s = s.replace(/[^0-9\-]/g, '');
        const n = parseFloat(s);
        return Number.isFinite(n) ? n : 0;
      }
    const [contas, setContas] = React.useState([]);
    const isEditing = form._isEditing;

    React.useEffect(() => {
      if (!show || !form.idPrograma) {
        setContas([]);
        return;
      }
      const token = localStorage.getItem('token');
      const cnpj = localStorage.getItem('cnpj');
      axios.get(`${API_BASE_URL.CONTA}/findByEscolaAndPrograma`, {
        params: { idEscola: cnpj, idPrograma: form.idPrograma },
        headers: { Authorization: `Bearer ${token}` }
      }).then(r => {
        const data = Array.isArray(r.data) ? r.data : [];
        function parseContaNum(numConta) {
          const m = String(numConta).match(/^(\d+)/);
          return m ? parseInt(m[1], 10) : 0;
        }
        setContas([...data].sort((a, b) => {
          const nA = parseContaNum(a.numConta);
          const nB = parseContaNum(b.numConta);
          if (nA !== nB) return nA - nB;
          return String(a.numConta).localeCompare(String(b.numConta));
        }));
        if (data.length === 1) {
          handleChange({ target: { name: 'idConta', value: data[0].numConta } });
        }
      }).catch(() => setContas([]));
    }, [show, form.idPrograma]);

    function handleContaSelect(e) {
      // propagate to parent
      handleChange(e);
      const conta = e.target.value;
      if (!conta) return;
      if (isEditing) return; // only auto-fill on new
      // find srea entries for this conta and program
      const filtered = (sreaEntries || []).filter(it => String(it.idConta) === String(conta) && String(it.idPrograma) === String(form.idPrograma));
      if (filtered.length === 0) {
        // no entries for this conta: reset values
        handleChange({ target: { name: 'vlrC', value: '0' } });
        handleChange({ target: { name: 'vlrK', value: '0' } });
        return;
      }
      const sumC = filtered.reduce((acc, it) => acc + (parseFloat(it.vlrC || 0) || 0), 0);
      const sumK = filtered.reduce((acc, it) => acc + (parseFloat(it.vlrK || 0) || 0), 0);
      // update form values via parent's handleChange
      handleChange({ target: { name: 'vlrC', value: String(sumC) } });
      handleChange({ target: { name: 'vlrK', value: String(sumK) } });
    }

    function handleProgramaSelect(e) {
      // when program changes, reset conta and values (only for new records)
      handleChange(e);
      if (isEditing) return;
      // clear selected conta and value fields
      handleChange({ target: { name: 'idConta', value: '' } });
      handleChange({ target: { name: 'vlrC', value: '0' } });
      handleChange({ target: { name: 'vlrK', value: '0' } });
      // also reset ajuste display (will be reloaded by effect)
      setAjusteVlrC(0);
      setAjusteVlrK(0);
      setTotalVlrC(0);
      setTotalVlrK(0);
      setContas([]);
    }
  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-arrow-repeat me-2"></i>CADASTRO DE SALDO REPROGRAMADO EXERCÍCIO ANTERIOR</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Programa *</label>
                  <select className="form-select form-select-sm" name="idPrograma" value={form.idPrograma} onChange={handleProgramaSelect} required disabled={isEditing}>
                    <option value="">Selecione...</option>
                    {programas.map(p => <option key={p.id} value={p.id}>{p.descricao}</option>)}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Conta *</label>
                  <select className="form-select form-select-sm" name="idConta" value={form.idConta} onChange={handleContaSelect} required disabled={!form.idPrograma || isEditing}>
                    <option value="">{form.idPrograma ? 'Selecione...' : 'Selecione o programa'}</option>
                    {contas.map(c => <option key={c.numConta} value={c.numConta}>{c.numConta}</option>)}
                  </select>
                </div>
              </div>
              {form.idPrograma && (
                <div className="row mb-2">
                  <div className="col-md-4">
                    <label className="form-label small">Total Custeio</label>
                    <div className="form-control form-control-sm bg-light">{formatCurrency(totalVlrC)}</div>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">Total Capital</label>
                    <div className="form-control form-control-sm bg-light">{formatCurrency(totalVlrK)}</div>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">Total Programa</label>
                    <div className="form-control form-control-sm bg-light">{formatCurrency((totalVlrC || 0) + (totalVlrK || 0))}</div>
                  </div>
                </div>
              )}
              {form.idPrograma && (
                <div className="row mb-2">
                  <div className="col-md-4">
                    <label className="form-label small">Ajuste Custeio</label>
                    <div className="form-control form-control-sm bg-light">{formatCurrency(ajusteVlrC)}</div>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">Ajuste Capital</label>
                    <div className="form-control form-control-sm bg-light">{formatCurrency(ajusteVlrK)}</div>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">Ajuste Total</label>
                    <div className="form-control form-control-sm bg-light">{formatCurrency((ajusteVlrC || 0) + (ajusteVlrK || 0))}</div>
                  </div>
                </div>
              )}
              {/* Escola e Ano removidos, pois vêm do storage */}
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'end' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label className="form-label" style={{ minHeight: '1.1rem', display: 'block' }}>Valor Custeio</label>
                  <CurrencyInput className="form-control form-control-sm" name="vlrC" value={form.vlrC} onChange={handleChange} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label className="form-label" style={{ minHeight: '1.1rem', display: 'block' }}>Valor Capital</label>
                  <CurrencyInput className="form-control form-control-sm" name="vlrK" value={form.vlrK} onChange={handleChange} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label className="form-label small" style={{ minHeight: '1.1rem', display: 'block' }}>Total</label>
                  <div className="form-control form-control-sm bg-light fw-bold">{formatCurrency(parseBRNumber(form.vlrC) + parseBRNumber(form.vlrK))}</div>
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
            {/* Tabela Saldo - abaixo do form */}
            {form.idPrograma && (
              <div className="mt-3">
                {isLoadingSaldo ? (
                  <div className="text-center py-2"><span className="spinner-border spinner-border-sm"></span></div>
                ) : errorSaldo ? (
                  <div className="alert alert-danger text-center my-2">{errorSaldo}</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Conta</th>
                          <th className="text-end">Saldo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contasArray.map((item, idx) => (
                          <tr key={item.idConta}>
                            <td>{idx + 1}</td>
                            <td>{item.idConta}</td>
                            <td className="text-end">{formatCurrency(item.valor)}</td>
                          </tr>
                        ))}
                        {contasArray.length > 0 && (
                          <tr className="table-secondary fw-bold">
                            <td colSpan={2} className="text-end">Total</td>
                            <td className="text-end">{formatCurrency(contasArray.reduce((acc, item) => acc + item.valor, 0))}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SreaModal;
